import $ from 'jquery';

export default class BackTop {
    constructor() {
        if ($('.js-back-top').length) {
            $('body').on('click', '.js-back-top', function() {
                $('html, body').animate({scrollTop : 0}, 800);
                return false;
            });
        };
    };
};
